import React from 'react'
import cx from 'classnames'
import { AnimatePresence } from 'framer-motion'

import FullBleedContainer from './FullBleedContainer'
import DealsFiltersContent, { FiltersFormInputs } from './DealsFiltersContent'

export enum DealsType {
  LIVE = 'live',
  COMPLETED = 'completed',
}

type DealsFiltersProps = {
  type: string
  showCompleted: boolean
  isCompletedLayout: boolean
  onSearch: (data: FiltersFormInputs) => void
  onChangeType: (type: DealsType) => void
}

function DealsFilters(props: DealsFiltersProps) {
  const { type, showCompleted, isCompletedLayout, onChangeType, onSearch } =
    props
  const [isOpenFilters, setOpenFilters] = React.useState(false)

  return (
    <>
      <div className="deals-filters">
        {Object.values(DealsType)
          .filter((e) =>
            showCompleted ? true : e.toLowerCase() !== 'completed'
          )
          .map((dealTypeItem) => (
            <button
              key={dealTypeItem}
              onClick={() => onChangeType(dealTypeItem)}
              className={cx('deals-filters-button', {
                active: dealTypeItem === type,
              })}
            >
              {dealTypeItem.toUpperCase()}
            </button>
          ))}
        <button
          className="deals-filters-button ml-2 !border-0"
          onClick={() => setOpenFilters((prevOpen) => !prevOpen)}
        >
          <svg
            width="13"
            height="10"
            viewBox="0 0 13 10"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10.0562"
              cy="7.49179"
              r="1.50937"
              stroke="currentColor"
            />
            <path d="M8.54684 7.49219H1" stroke="currentColor" />
            <circle
              cx="2.51022"
              cy="2.51016"
              r="1.50937"
              transform="rotate(-180 2.51022 2.51016)"
              stroke="currentColor"
            />
            <path d="M4.01957 2.50976L11.5664 2.50977" stroke="currentColor" />
          </svg>
          <span className="ml-2">FILTERS</span>
        </button>
        <style jsx>{`
          .deals-filters {
            @apply mb-4 flex;
          }
          .deals-filters-button {
            @apply flex h-[44px] w-[115px] items-center justify-center border border-dashed border-black bg-transparent px-4 font-ibm text-xs font-semibold text-black transition-all duration-500 ease-in-out first:border-r-0;
          }
          .deals-filters-button:nth-child(2) {
            @apply border-l-0;
          }
          .deals-filters-button.active,
          .deals-filters-button:hover {
            @apply bg-black text-white;
          }
        `}</style>
      </div>
      <FullBleedContainer className="bg-white-100">
        <DealsFiltersContent
          open={isOpenFilters}
          isCompletedLayout={isCompletedLayout}
          onSearch={(data) => [setOpenFilters(false), onSearch(data)]}
        />
      </FullBleedContainer>
    </>
  )
}

export default DealsFilters
